// Utility function to get API base URL from environment variable
export const getApiBaseUrl = () => {
  return process.env.REACT_APP_API_URL || "http://localhost:5000/api";
};

// Utility function to make authenticated fetch requests
export const authenticatedFetch = (url, options = {}) => {
  const token = localStorage.getItem('token');
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };

  return fetch(`${getApiBaseUrl()}${url}`, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers
    }
  });
};

export default { getApiBaseUrl, authenticatedFetch };